// import { fetch } from './zk-fetch'
import fetch from './fetch'

/**
 * 解析链接
 * @param {*} params
 * @param {String} params.url 【必须】链接地址
 */
export const zdLinkAnalyze = (params) => {
  return fetch.exec('/zd_link_analyze', params)
}

/**
 * 扎堆发布链接
 * @param {*} params
 * @param {String} article_id 文章id
 * @param {String} discussion_id 社区id
 * @param {String} channel_id 频道id
 * @param {String} content 分享内容
 */
export const zdLinkPublish = (params) => {
  return fetch.exec('/zd_link_publish', params, { method: 'POST' })
}